import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { Card } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import {
  AdmissionProcessManagementLoaderProvider,
  useAdmissionProcessManagementLoader,
} from './parts/managementLoader';
import Loading from '../../../components/info/Loading';
import GoBackToListButton from '../../../components/buttons/GoBackToListButton';
import BulkOffersEditor from './parts/AdmissionProcessOffers/BulkOffersEditor';

function AdmissionProcessBulkOffersContent({
  processId,
  onDone,
}: {
  processId: number;
  onDone: () => void;
}) {
  const { t } = useTranslation('academic-offer/admission-processes');
  const { data, loading, refresh } = useAdmissionProcessManagementLoader();

  if (loading) {
    return <Loading insideCard />;
  }

  if (!data) {
    return <div>{t('errors.notFound')}</div>;
  }

  const { process, availableOffers } = data;
  return (
    <BulkOffersEditor
      processId={process.id}
      offers={process.offers}
      availableOffers={availableOffers.offers}
      admissionVias={availableOffers.admissionVias}
      academicOfferQuota={process.academicOfferQuota}
      refresh={refresh}
      onDone={onDone}
    />
  );
}

export default function AdmissionProcessBulkOffersPage() {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  return (
    <Card className="p-4 mx-3">
      <div className="mx-3 mt-2">
        <GoBackToListButton
          path={`/academic-offer/admission-processes/${id}`}
        />
        <AdmissionProcessManagementLoaderProvider
          defaultQuery={{ id: Number(id) }}
          fetchImmediately
        >
          <AdmissionProcessBulkOffersContent
            processId={Number(id)}
            onDone={() =>
              history.push(`/academic-offer/admission-processes/${id}`)
            }
          />
        </AdmissionProcessManagementLoaderProvider>
      </div>
    </Card>
  );
}
